export const convertAppDeeplinkToWebUrl = (deeplink: string): string => {
  const scheme = `xyz.be.customer://`

  const webUrl = deeplink.replace(scheme, `/`)

  return webUrl
}
